import { createSlice } from "@reduxjs/toolkit";

const initialState = { jobCodeData: {}, workgroupData: {} };

const buildJobCodeData = (ddbData) => {
  let jobCodeData = {};
  ddbData.forEach((jobCodeObj) => {
    const jobCode = jobCodeObj.job_code;
    jobCodeData[jobCode] = {
      title: jobCodeObj.title,
      workgroup: jobCodeObj.workgroup,
      defaultAccessLevel: jobCodeObj.default_access_level,
      unionContract: jobCodeObj.union_contract,
      accessOverrideEligible: jobCodeObj.access_override_eligible,
      torTypes: jobCodeObj.torTypes,
    };
  });
  return jobCodeData;
};

const buildWorkgroupData = (ddbData) => {
  let workgroupData = {};
  ddbData.forEach((workgroupObj) => {
    const workgroup = workgroupObj.workgroup;
    workgroupData[workgroup] = {
      eligibleWorkgroups: workgroupObj.eligible_workgroups,
      eligibleTradeAgentAndSup: workgroupObj.eligible_trade_agent_and_sup,
      eligibleGiveawayWorkgroups: workgroupObj.eligible_giveaway_workgroups,
      unionContract: workgroupObj.union_contract,
      accessOverrideEligible: workgroupObj.access_override_eligible,
      jobCodes: workgroupObj.job_codes,
    };
  });
  return workgroupData;
};

export const commonConfigSlice = createSlice({
  name: "commonConfig",
  initialState,
  reducers: {
    setJobCodeData: (state, action) => {
      state.jobCodeData = buildJobCodeData(action.payload);
    },
    setWorkgroupData: (state, action) => {
      state.workgroupData = buildWorkgroupData(action.payload);
    },
    clearCommonConfigState: (state) => initialState,
  },
});

export const { setJobCodeData, setWorkgroupData, clearCommonConfigState } = commonConfigSlice.actions;

export const selectJobCodeData = (state) => state.commonConfig.jobCodeData;

export const selectWorkgroupData = (state) => state.commonConfig.workgroupData;

export default commonConfigSlice.reducer;
